import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SmmPostService } from '../../_services/smm-post.service';
import { SmmService } from '../../_services/smm.service';
import { DashboardFilterService } from 'app/views/dashboards/dashboard-filter/dashboard-filter.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

const Highcharts = require('highcharts');

declare var global: any;
const Color = global.Color;

@Component({
  selector: 'app-semi-pie-chart',
  templateUrl: './semi-pie-chart.component.html',
  styleUrls: ['./semi-pie-chart.component.scss']
})
export class SemiPieChartComponent implements OnChanges {

  // Input
  @Input() names: Array<string>;
  @Input() counts: Array<number>;
  @Input() project: Array<string>;
  @Input() searchKeyword: string;
  @Input() dateInput: any;
  @Input() displayDateInput: string;
  @Input() height: any;  
  @Input() legendOption: any;
  @Input() bgColor: string;
  @Input() chartTitle: string;
  @Input() detailTitle: string;
  @Input() chartDescription: string;
  @Input() chartSubTitle: string;
  @Input() dataEmpty: boolean;
  @Input() chartWidth: number;
  @Input() marginTop: number;
  @Input() projectName: string;

  public filterSemiPieChart: any;

  // Chart
  public chartOptions: any;

  // Modal
  modalRef: BsModalRef;
  public config = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };

  // Sub
  subscription: Subscription;

  // DỮ LIỆU HIỂN THỊ LÊN POPUP
  public posts: Array<any> = [];
  public pages: Map<string, any> = new Map<string, any>();
  public groups: Map<string, any> = new Map<string, any>();
  public currentPosts = [];
  public titleModel: string;
  public sentimentPost: string;

  // Spin
  public isLoading = true;
  public errorMsg = "";

  constructor(private toastrService: ToastrService
    , private modalService: BsModalService
    , private smmPostService: SmmPostService
    , private smmService: SmmService
    , private dashboardFilterService: DashboardFilterService
    , private router: Router) {
    this.subscription = this.dashboardFilterService.getData().subscribe(filter => {
      this.filterSemiPieChart = filter;      
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // // //Lucnt Comment//console.log('vào ngOnChanges');
    if (this.names !== undefined && this.counts !== undefined) {
      this.createChart();
    }
  }

  private capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  public createChart() {
    const series = [{
      name: 'Số lượng 123',
      colorByPoint: true,
      data: [],
      innerSize: '50%' // todo
    }];
    let index = 0;
    for (const name of this.names) {
      // const temp = { name: this.capitalizeName(name), y: this.counts[index] };
      const temp = { name: name, y: this.counts[index], projectId: this.project };
      series[0].data.push(temp);
      index += 1;
    }

    this.chartOptions = {
      title: { // todo
        text: this.chartDescription,
        align: 'center',
        verticalAlign: 'middle',
        y: 40,
        style: { fontSize: '12px', color: '#6495ED' }
      },
      subtitle: {
        text: this.chartSubTitle,
        align: 'center',
        verticalAlign: 'middle',
        y: 120,
        style: { fontSize: '12px', color: '#6495ED' }
      },
      chart: {
        plotBackgroundColor: null,
        backgroundColor: this.bgColor || null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        marginTop: this.marginTop || 55,        
        width: this.chartWidth || 300
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer', // todo
          dataLabels: {            
            enabled: true,
            distance: -25, // todo
            // format: '<span style="font-weight: normal">{point.y}</span> ' + this.detailTitle,
            // format: '<span style="">{point.percentage:.2f}</span> %',
            formatter: function () {
              if (this.y > 0) {
                // return this.point.name + ': ' + Highcharts.numberFormat(this.point.percentage, 1) + ' %'
                return Highcharts.numberFormat(this.point.percentage, 2) + '%';
              }
            },
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'white',
              // fontFamily: 'Arial, Helvetica, Verdana, sans-serif;'
            }
          },
          showInLegend: true,
          startAngle: -90, // todo
          endAngle: 90, // todo
          // size: '120%'
        }
      },
      tooltip: {
        shared: true,
        formatter: function () {
          // return this.series.name + ':<b>' + this.y + '</b> ' 
          //  + '<br>Tỷ lệ: <b>' + Highcharts.numberFormat(this.percentage, 2) + '%</b> ';
          if(this.series !== undefined){
            console.log(this.key);
            // return this.series.name + ':<b>' + this.y + '</b> ';
            return this.key + ':<b>' + this.y + '</b> ';
          }else {
            return "";
          }
          
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      legend: {
        layout: this.legendOption ? this.legendOption.layout : 'horizontal',
        align: this.legendOption ? this.legendOption.align : 'center',
        x: 0,
        y: 0,
        verticalAlign: 'top',
        floating: true,
        backgroundColor: this.bgColor || (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
        itemStyle: {
          fontWeight: 'normal',
          color: '#00BFFF'          
        },
        itemHoverStyle: {
          color: 'green'
        },
        // itemWidth: 400
      },
      colors: [
        Color('#037110').alpha(0.8).rgbString(),
        Color('#bcc0c3').alpha(0.8).rgbString(),
        Color('#f74459').alpha(0.8).rgbString()
      ],
      series: series
    };
  }

  /*======================================= EVENT CLICK CHART - START =======================================*/
  public chartClicked(e: any, template): void {
    console.log(this.filterSemiPieChart);
    if(e.point !== undefined){
      let sentiment = [];
      if (e.point.options.name == "Tiêu cực") {
        this.titleModel = "Danh sách bài viết tiêu cực";
        this.sentimentPost = "neg";
      } else if (e.point.options.name == "Tích cực") {
        this.sentimentPost = "pos";
        this.titleModel = "Danh sách bài viết tích cực";   
      } else if (e.point.options.name == "Trung tính") {
        this.sentimentPost = "neu";
        this.titleModel = "Danh sách bài viết trung tính";   
      }
      sentiment.push(this.sentimentPost);
      let from = 0;
      let size = 20;
      let gte = this.filterSemiPieChart.gte;
      let lte = this.filterSemiPieChart.lte;
      // let projectIds = this.filterSemiPieChart.projectSelectedIds;
      let projectIds = e.point.options.projectId;
      this.filterSemiPieChart.projectSelectedIds = projectIds;
      let provinces = this.filterSemiPieChart.provinces;
      this.posts = [];
      this.currentPosts = [];
      
      // Modal
      this.modalRef = this.modalService.show(template, this.config);
      $(".modal-content").css({
        "background": "#7a2d2e",
        "opacity": "1",
        "color": "#FFFFFF"
      });
      
      // API Backend
      this.searchPosts(from, size, projectIds, lte, gte, sentiment, this.posts, this.pages, this.groups, provinces);
    }

  }

  /*======================================= EVENT CLICK CHART - END =======================================*/

  /*======================================= CALL API BACKEND - START =======================================*/
  public searchPosts(from, size, projectIds, lte, gte, sentiment, posts, pages, groups, provinces) {
    this.smmPostService.searchDetailDiscussion({
      from: from,
      size: size,
      filter: {
        lte: lte,
        gte: gte,
        // docTypes: ['user_post', 'page_post', 'group_post'],
        // docTypes: ['news_article', 'news_blog', 'news_forum'],
        docTypes: ['user_post', 'page_post', 'group_post', 'news_article', 'news_blog', 'news_forum'],        
        sentiment: sentiment,
        projectIds: projectIds,
        provinces: provinces,
        typeChart: 'semi-pie-chart'
      }
    }).subscribe(response => {
      if (response.success) {
        this.isLoading = false;
        if (response.data.hits.total.value > 0) {
          this.currentPosts = [];
          const pageIdArray = [];
          const groupIdArray = [];
          const userIdArray = [];

          for (const post of response.data.hits.hits) {
            post.showContent = false;

            // TMHIEP - 14/05/2020 - START
            post['_source']['sentiment'] = "";
            post['_source']['sentimentCode'] = "";
            let sentimentArray = [];
            if (post['_source']['topicSentiment'] !== undefined) {
              sentimentArray = post['_source']['topicSentiment'];
              for (let index = 0; index < sentimentArray.length; index++) {
                const element = sentimentArray[index];
                if (element.id == projectIds[0].toString()) {
                  let sentiment = element.sentiment;
                  if (sentiment == 'neu') {
                    post['_source']['sentiment'] = "Trung tính";
                    post['_source']['sentimentCode'] = "neu";
                  } else if (sentiment == 'pos') {
                    post['_source']['sentiment'] = "Tích cực";
                    post['_source']['sentimentCode'] = "pos";
                  } else if (sentiment == 'neg') {
                    post['_source']['sentiment'] = "Tiêu cực";
                    post['_source']['sentimentCode'] = "neg";
                  }
                  break;
                }
              }
            }
            // TMHIEP - 14/05/2020 - END

            // TMHIEP - 12/08/2020 - START - BÁO
            post['_source']['docTypeName'] = "";
            if (post['_source']['docType'] == "news_article") {
              post['_source']['docTypeName'] = "Báo chí";
              post['_source']['message'] = post['_source']['content'];
            } else if (post['_source']['docType'] == "news_blog") {
              post['_source']['docTypeName'] = "Blog";
              post['_source']['message'] = post['_source']['content'];
            } else if (post['_source']['docType'] == "news_forum") {
              post['_source']['docTypeName'] = "Forum";
              post['_source']['message'] = post['_source']['content'];
            }
            // TMHIEP - 12/08/2020 - END

            posts.push(post);
            if (post['_source'].userId) {
              post['_source']['sourceId'] = post['_source'].userId;
            } else {
              post['_source']['sourceId'] = post['_source'].pageId;
            }

            // if (!pages.has(post['_source'].sourceId)) { 
            if (post['_source'].docType === 'page_post') {
              if (post['_source'].sourceId !== undefined && pageIdArray.indexOf(post['_source'].sourceId) === -1) {
                pageIdArray.push(post['_source'].sourceId);
              }
            } else if (post['_source'].docType === 'user_post' || post['_source'].docType === 'group_post') {
              if (post['_source'].sourceId != null && userIdArray.indexOf(post['_source'].sourceId) === -1) {
                userIdArray.push(post['_source'].sourceId);
              }
              if (post['_source'].groupId !== undefined) {
                if (groupIdArray.indexOf(post['_source'].groupId) === -1) {
                  groupIdArray.push(post['_source'].groupId);
                } else {
                  // alert(JSON.stringify(groupIdArray));
                  // alert('hiep:    ' + post['_source'].groupId);
                }
              } else {
                // alert('undefined rồiiii');
              }
            }
            // }else{
            //   // alert(JSON.stringify(pages));
            //   // alert(post['_source'].sourceId);
            // }
          }
          
          if (pageIdArray.length > 0) {
            // console.log("=================pageIdArray===========");
            // console.log(pageIdArray);
            this.smmService.getPagesByIds(pageIdArray).subscribe(response1 => {
              const docs = response1.data.docs;
              for (const doc of docs) {
                if (doc['found']) {
                  pages.set(doc['_id'], doc['_source']);
                } else {
                  pages.set(doc['_id'], null);
                }
              }
            });
          }
          if (groupIdArray.length > 0) {
            // alert(groupIdArray.length);
            // console.log("=================groupIdArray===========");
            // console.log(groupIdArray);
            this.smmService.getGroupsByIds(groupIdArray).subscribe(response1 => {
              const docs = response1.data.docs;
              for (const doc of docs) {
                if (doc['found']) {
                  // console.log("====group info====")
                  // console.log(doc['_source']);                 
                  groups.set(doc['_id'], doc['_source']);
                } else {
                  groups.set(doc['_id'], null);
                }
              }
            });
          }
          if (userIdArray.length > 0) {
            // console.log("=================userIdArray===========");
            // console.log(userIdArray);
            this.smmService.getUsersByIds(userIdArray).subscribe(response1 => {
              if (response1.data !== undefined && response1.data.docs !== undefined) {
                const docs = response1.data.docs;
                for (const doc of docs) {
                  if (doc['found']) {
                    pages.set(doc['_id'], doc['_source']);
                  } else {
                    pages.set(doc['_id'], null);
                  }
                }
              }

            });
          }          
          this.errorMsg = "";          
          this.currentPosts = this.posts;
        } else {
          this.isLoading = false;
          this.currentPosts = [];          
          this.errorMsg = 'Không tìm thấy dữ liệu!';
        }
      } else {
        this.isLoading = false;
        this.currentPosts = [];
        this.errorMsg = 'Có lỗi xảy ra! Không tìm thấy dữ liệu!';
      }
    }
    );
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/semi-pie-chart/semi-pie-chart.component.ts